// Config centrale des agents IA (OH)
// Source unique des thèmes visuels et endpoints.
// Respecte la règle no-hardcode : tout composant `<AgentPanel agent="depot" />`
// lit ici ses couleurs, icône, endpoint et copy.
//
// Pour ajouter un nouvel agent :
//   1. Ajouter son entrée dans AGENTS ci-dessous
//   2. Le backend doit exposer POST {endpoint} avec un body {reference, message?}
//      et renvoyer {verdict, analysis, tool_calls_log, session_id, iterations, duration_ms}
//   3. Le front AgentPanel fonctionnera automatiquement.
//
// Date : 2026-04-21 (création dans le cadre de l'Agent Dépôt)

import { Shield, Ruler, Bot } from "lucide-react";

export const AGENTS = {
  depot: {
    id: "depot",
    label: "Agent Dépôt",
    description: "Vérifie la complétude du dossier pour le dépôt ANAH MaPrimeAdapt'.",
    icon: Shield,
    // Palette (couleurs Tailwind, pas de hardcode hex dispersé)
    palette: {
      badge: "bg-blue-500/15 text-blue-400 border-blue-500/30",
      ring: "ring-blue-500/30",
      accent: "text-blue-400",
      button: "bg-blue-600 hover:bg-blue-700 text-white",
      softBg: "bg-blue-500/5",
      softBorder: "border-blue-500/20",
    },
    // Endpoints backend (POST run, GET history)
    endpoints: {
      run: "/api/metier/agents/depot/run",
    },
    // Verdicts possibles + badge
    verdicts: {
      "PRÊT": { label: "PRÊT AU DÉPÔT", color: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
      "INCOMPLET": { label: "INCOMPLET", color: "bg-orange-500/15 text-orange-400 border-orange-500/30" },
      "BLOQUÉ": { label: "BLOQUÉ", color: "bg-red-500/15 text-red-400 border-red-500/30" },
      "ATTENTION": { label: "ATTENTION", color: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
      "INCONNU": { label: "INCONNU", color: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30" },
    },
    // Message utilisateur par défaut (peut être overridé)
    defaultPrompt: "Vérifie la complétude de ce dossier pour le dépôt ANAH MaPrimeAdapt'.",
  },

  dal: {
    id: "dal",
    label: "Agent DAL",
    description: "Génération de Demande Administrative de Logement.",
    icon: Ruler,
    palette: {
      badge: "bg-orange-500/15 text-orange-400 border-orange-500/30",
      ring: "ring-orange-500/30",
      accent: "text-orange-400",
      button: "bg-orange-600 hover:bg-orange-700 text-white",
      softBg: "bg-orange-500/5",
      softBorder: "border-orange-500/20",
    },
    endpoints: { run: "/api/metier/agents/dal/run" },
    verdicts: {},
    defaultPrompt: "Génère la DAL pour ce dossier.",
  },

  // T-415 (IA-2) : entrées `suivi` et `admin_ventes` RETIRÉES — leurs routes
  // (/api/metier/agents/suivi|admin-ventes/run) n'existent pas. Chloé (Hub Commercial)
  // passe par /api/sales-admin/chat (CxOChatPanel), pas par AgentPanel.
};

/** Récupère la config d'un agent avec fallback safe. */
export function getAgentConfig(agentId) {
  return AGENTS[agentId] || {
    id: agentId,
    label: agentId,
    description: "",
    icon: Bot,
    palette: {
      badge: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
      ring: "ring-zinc-500/30",
      accent: "text-zinc-400",
      button: "bg-zinc-600 hover:bg-zinc-700 text-white",
      softBg: "bg-zinc-500/5",
      softBorder: "border-zinc-500/20",
    },
    endpoints: { run: `/api/metier/agents/${agentId}/run` },
    verdicts: {},
    defaultPrompt: "",
  };
}
